import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

    export class Mushroom extends FootchinkoItem {

        constructor(game: Phaser.Game, x: number, y: number, hits: number) {

            super ( game, x, y, "texture_atlas_1", true, false, 0 , null, hits);

            this.canBeHit = true;
        }

        public setBody(): void {

            this.body.setZeroVelocity();
            this.body.static = true;
            this.body.setCircle(15);
            this.body.setMaterial(GameVars.getInstance().materials.pegMaterial);
        }

        public setView(): void {

            super.setView();

            this.burntFrameName =  "burnt-peg";

            switch ( this.hits ) {

                case 4:
                    this.name = GameConstants.PEG_4;
                    this.frameName = "peg-4";
                    break;
                case 3:
                    this.name = GameConstants.PEG_3;
                    this.frameName = "peg-3";
                    break;
                case 2:
                    this.name = GameConstants.PEG_2;
                    this.frameName = "peg-2";
                    break;
                case 1:
                    this.name = GameConstants.PEG_1;
                    this.frameName = "peg-1";
                    break;
                default:
            }

            this.animations.add("disappear", Phaser.Animation.generateFrameNames("peg_disappear_", 1, 4 , "", 4));
        }

        public hit(): void {

           super.hit();

           if (this.hits === 0) {

                this.animations.play("disappear", 30)
                    .onComplete.add(this.kill, this);

           } else {

               switch (this.hits) {
                   case 3:
                       this.name = GameConstants.PEG_3;
                       this.frameName = "peg-3";
                       break;
                   case 2:
                       this.name = GameConstants.PEG_2;
                       this.frameName = "peg-2";
                       break;
                   case 1:
                       this.name = GameConstants.PEG_1;
                       this.frameName = "peg-1";
                       break;
                   default:
               }

               let scaleX = Math.random() > .5 ? 1.1 : 1.35;
               let scaleY = Math.random() > .5 ? 1.1 : 1.35;

               this.scale.setTo(scaleX, scaleY);

               this.game.time.events.add(100, function(): void {
                   this.scale.set(1);
                }, this);
           }

           AudioManager.getInstance().playEffect("rebote_seta_1");
        }
    }
